import { CommonServiceUtils, CustomUrl } from "./common-service-utils";
import { productTypes } from "./productTypes";
import queryString from 'query-string';

export class ServiceApi extends CommonServiceUtils {
  async fetchUserStores(req) {
    let response = [];
    const fetchUserStores = await this.postData(
      `${this.apiUrlCreator(`getuserstores`, CustomUrl.USERS)}`,
      req
    );

    if (fetchUserStores.statusCode === 200) {
      response = fetchUserStores?.data?.stores || [];
    }
    return response;
  }

  async fetchManageFlavors(req) {
    let response = [];
    const manageFlavorsData = await this.postData(
      `${this.apiUrlCreator(`getflavorslist`, CustomUrl.FLAVORS)}`,
      req
    );
    if (manageFlavorsData) {
      response = manageFlavorsData || [];
    }
    return response;
  }

  async fetchProductTypes() {
    let response = [];
    const productTypes = await this.getData(
      `${this.apiUrlCreator(`getflavorproducttypes`, CustomUrl.PRODUCT_TYPES)}`
    );
    if (productTypes) {
      response = productTypes?.data || [];
    }
    return response;
  }

  async flavorCRUDOperations(req) {
    const fetchStoreFlavors = await this.postData(
      `${this.apiUrlCreator(`flavorcrud`, CustomUrl.FLAVORS)}`,
      req
    );

    return fetchStoreFlavors;
  }

  async fetchManageFlavorsFileDownloadURL(req) {
    let response = [];
    const manageFlavorsData = await this.postData(
      `${this.apiUrlCreator(`exportflavorslist`, CustomUrl.FLAVORS)}`,
      req
    );
    if (manageFlavorsData?.statusCode === 200) {
      response = manageFlavorsData;
    }
    return response;
  }

  async productTypes() {
    return productTypes;
  }

  async fetchStoreFlavors(req) {
    let response = [];
    const fetchStoreFlavors = await this.postData(
      `${this.apiUrlCreator(`getstoreflavors`, CustomUrl.STORES)}`,
      req
    );
    if (fetchStoreFlavors.statusCode === 200) {
      response = fetchStoreFlavors?.data || [];
    }
    return response;
  }

  async updateStoreFavourite(req) {
    let response = {};
    try {
      const res = await this.postData(`${this.apiUrlCreator(`storefavourite`, CustomUrl.STORES)}`, req)
      if (res?.message) response = res || {};
    }
    catch (err) {
      console.log('updateStoreFavourite error ', err);
    }
    return response;
  }

  async updateFlavors(req) {
    const fetchStoreFlavors = await this.postData(
      `${this.apiUrlCreator(`updatestoreflavors`, CustomUrl.STORES)}`,
      req
    );
    return fetchStoreFlavors;
  }


  async fetchFCUserList(payload) {
    let response = [];
    const fetchFCUsers = await this.postData(
      `${this.apiUrlCreator(`getfcusers`, CustomUrl.USERS)}`,
      payload
    );

    if (fetchFCUsers?.statusCode === 200) {
      response = fetchFCUsers?.data?.fc_users || [];
    }
    return response;
  }

  async fetchFCStores(payload) {
    let response = [];
    const fetchFCUsers = await this.postData(
      `${this.apiUrlCreator(`getuserstores`, CustomUrl.USERS)}`,
      payload
    );
    if (fetchFCUsers?.statusCode === 200) {
      response = fetchFCUsers?.data?.stores || [];
    }
    return response;
  }

  async fetchFlavorDrivenTreats() {
    let response = [];
    const fetchFlavorDrivenTreats = await this.getData(
      `${this.apiUrlCreator(`getflavordriventreats`, CustomUrl.FLAVORS)}`
    );
    if (fetchFlavorDrivenTreats.status === 200) {
      response = fetchFlavorDrivenTreats.data || [];
    }

    return response;
  }

  async addFlavrDrivenTreats(payload) {
    let response = [];
    const statusFlavorDrivenTreat = await this.postData(
      `${this.apiUrlCreator(`flavordriventreatscrud`, CustomUrl.FLAVORS)}`,
      payload
    );
    if (statusFlavorDrivenTreat.statusCode) {
      response = statusFlavorDrivenTreat || [];
    }
    return response;
  }

  async fetchFlavorDrivenProducts() {
    let response = [];
    const statusFlavorDrivenProducts = await this.getData(
      `${this.apiUrlCreator(`getflavordrivenproducts`, CustomUrl.FLAVORS)}`
    );
    if (statusFlavorDrivenProducts) {
      console.log(statusFlavorDrivenProducts, "from service api 162");
      response = statusFlavorDrivenProducts?.data || [];
    }

    return response;
  }

  async getHoursOperationData(storeID) {
    let response = [];
    const hoursgetData = await this.postData(
      `${this.apiUrlCreator(`gethoursofoperation`, CustomUrl.STORES)}`,
      storeID
    );
    if (hoursgetData.statusCode === 200) {
      response = hoursgetData.data;
    }

    return response;
  }
  async saveOpenCloseDates(payload) {
    let response = [];
    const hoursgetData = await this.postData(
      `${this.apiUrlCreator(`updatehoursofoperation`, CustomUrl.STORES)}`,
      payload
    );
    if (hoursgetData.statusCode) {
      response = hoursgetData;
    }

    return response;
  }
  async getpreselbanners(payload) {
    let response = [];
    const getpreselbanners = await this.postData(
      `${this.apiUrlCreator(`getpreselbanners`, CustomUrl.PRESELL_BOARD)}`, payload
    );
    response = getpreselbanners?.data?.presel_banners || [];
    return response
  }

  async sendCoolAlerts(req) {
    const response = await this.postData(
      `${this.apiUrlCreator(`sendcoolalerts`, CustomUrl.FLAVORS)}`,
      req
    );
    return response;
  }
  async SignInUser(req) {
    const response = await this.postData(
      `${this.apiUrlCreator(`signin`, CustomUrl.USERS)}`,
      req
    );
    return response;
  }

  async fetchProductionSheetCategories() {
    let response = [];
    const productTypes = await this.getData(
      `${this.apiUrlCreator(`getflavorproducttypes?type=productionsheet`, CustomUrl.PRODUCT_TYPES)}`
    );
    if (productTypes) {
      response = productTypes?.data || [];
    }
    return response;
  }

  async fetchPurchaseMerchendise() {
    let response = [];
    const purchaseCard = await this.getData(
      `${this.apiUrlCreator(`mrcproducts`, CustomUrl.MERCHANDISE_SITE)}`
    );
    if (purchaseCard) {
      response = purchaseCard?.data || [];
    }
    return response;
  }

  async updatePurchaseMerchandise(payload) {
    let response = [];
    const purchaseCard = await this.patchData(
      `${this.apiUrlCreator(`mrcupdateproduct`, CustomUrl.MERCHANDISE_SITE)}`,
      payload
    );
    if (purchaseCard) {
      response = purchaseCard?.data || [];
    }
    return response;
  }

  //Create the new purchase request 
  async createMerchandiseOrder(payload) {
    let response = [];
    const purchaseOrder = await this.postData(
      `${this.apiUrlCreator(`mrcorders`, CustomUrl.MERCHANDISE_SITE)}`,
      payload
    );

    return purchaseOrder;
  }


  async fetchProductionSheetFlavors(storeID, type) {
    let response = [];
    const manageFlavorsData = await this.getData(
      `${this.apiUrlCreator(`psstoreflavors?intStoreID=${storeID}&type=${type}`, CustomUrl.FLAVORS)}`
    );
    if (manageFlavorsData) {
      response = manageFlavorsData?.data || [];
    }
    return response;
  }

  async submitProductionSheetData(data) {
    const productionDataSubmitRes = await this.postData(`${this.apiUrlCreator(`createproductionsheet`, CustomUrl.PRODUCTION_SHEET)}`,
      data)
    return productionDataSubmitRes
  }

  async getProductionSheetData(req) {
    const productionDataRes = await this.postData(`${this.apiUrlCreator(`getproductionsheet`, CustomUrl.PRODUCTION_SHEET)}`,
      req)
    return productionDataRes
  }
  async updateproductionsheet(req) {
    const productionDataRes = await this.postData(`${this.apiUrlCreator(`updateproductionsheet`, CustomUrl.PRODUCTION_SHEET)}`,
      req)
    return productionDataRes
  }

  async submitUnlockAPi(req) {
    const unLockResp = await this.postData(`${this.apiUrlCreator(`updatepsdailysubmitstatus`, CustomUrl.PRODUCTION_SHEET)}`,
      req)
    return unLockResp
  }

  async getSnapShot(payload) {
    const getSnapShot = await this.postData(
      `${this.apiUrlCreator(`presellsnapshotupload`, CustomUrl.PRESELL_BOARD)}`, payload
    );
    console.log(getSnapShot)
    // response = getSnapShot?.data?.data?.presel_banners || [];
    return getSnapShot
  }


  async fetchStorePermissions(payload) {
    const fetchStorePermissions = await this.postData(
      `${this.apiUrlCreator(`getstorepermissions`, CustomUrl.STORES)}`,
      payload
    );
    return fetchStorePermissions
  }
  async fetchPresellOrderList(payload) {
    const fetchPresellOrderList = await this.postData(
      `${this.apiUrlCreator(`getPresellOrderList`, CustomUrl.PRESELL_BOARD)}`,
      payload
    );
    return fetchPresellOrderList
  }
  async getPresellStoreLevelOrderList(payload) {
    const getPresellStoreLevelOrderList = await this.postData(
      `${this.apiUrlCreator(`getPresellOrderList`, CustomUrl.PRESELL_BOARD)}`,
      payload
    );
    return getPresellStoreLevelOrderList
  }
  async savePresellBoardAdmin(payload) {
    const savePresellBoardAdmin = await this.postData(
      `${this.apiUrlCreator(`PresellBoardAdmin`, CustomUrl.PRESELL_BOARD)}`,
      payload
    );
    return savePresellBoardAdmin
  }
  async UpdateStoreLevelPresellStatus(payload) {
    const UpdateStoreLevelPresellStatus = await this.postData(
      `${this.apiUrlCreator(`presellStoreAdmin`, CustomUrl.PRESELL_BOARD)}`,
      payload
    );
    return UpdateStoreLevelPresellStatus
  }
  async savePresellBoardOrder(payload) {
    const savePresellBoardOrder = await this.postData(
      `${this.apiUrlCreator(`savePresellBoardOrder`, CustomUrl.PRESELL_BOARD)}`,
      payload
    );
    return savePresellBoardOrder
  }
  async deletepresellbanner(payload) {
    const deletepresellbanner = await this.postData(
      `${this.apiUrlCreator(`deletepresellbanner`, CustomUrl.PRESELL_BOARD)}`,
      payload
    );
    return deletepresellbanner
  }

  async purchaseMerchendiseCreateProduct(payload) {
    const response = await this.postData(
      `${this.apiUrlCreator(`mrccreateproduct`, CustomUrl.MERCHANDISE_SITE)}`,
      payload
    );
    return response;
  }

  async deleteproductionsheet(req) {
    const productionDataRes = await this.postData(`${this.apiUrlCreator(`deletePSdata`, CustomUrl.PRODUCTION_SHEET)}`,
      req)
    return productionDataRes
  }
  async fetchOnlineVendorsList(intStoreID) {
    const getOnlineVendorsList = await this.getData(`${this.apiUrlCreator(`onlinevendorordering?intStoreID=${intStoreID}`, CustomUrl.ONLINE_VENDOR_ORDERING)}`
    )
    return getOnlineVendorsList
  }

  //TOUR API
  async updateStatusForTourGuide(tourStatus, uid, userName) {
    let payload = {
      uid: uid,
      user_name: userName,
      tourStatus: tourStatus
    }
    let resp = await this.postData(`${this.apiUrlCreator(`tourifyuser`, CustomUrl.USERS)}`, payload)
    return resp;
  }

  async getProductionReports(params) {
    const qs = queryString.stringify(params);
    const reportsRes = await this.getData(`${this.apiUrlCreator(`getproductionreportsdata?${qs}`, CustomUrl.PRODUCTION_SHEET)}`);
    return reportsRes?.data || [];
  }

  async fetchWeatherHistory(payload) {
    const fetchWeatherData = await this.getData(
      `${`${process.env.REACT_APP_WEATHER_API_URL}/history.json?key=${payload.key}&q=${payload.geo}&dt=${payload.dt}&hour=${payload.hr}`}`,
      payload
    );
    return fetchWeatherData
  }

  async fetchCurrentWeatherInfo(payload) {
    const fetchWeatherData = await this.getData(
      `${`${process.env.REACT_APP_WEATHER_API_URL}/current.json?key=${payload.key}&q=${payload.geo}&dt=${payload.dt}&hour=${payload.hr}`}`,
      payload
    );
    return fetchWeatherData
  }

  async saveOrUpdateOnlineVendor(req) {
    const saveVendor = await this.postData(`${this.apiUrlCreator(`onlinevendorordering`, CustomUrl.ONLINE_VENDOR_ORDERING)}`,
      req)
    return saveVendor
  }

  async deleteOnlineVendor(intVendorGatewayID) {
    const deleteVendor = await this.patchData(`${this.apiUrlCreator(`onlinevendorordering?intVendorGatewayID=${intVendorGatewayID}`, CustomUrl.ONLINE_VENDOR_ORDERING)}`)
    return deleteVendor
  }
  async getFieldsByVendorId(intVendorGatewayID) {
    const getvendoraddedfields = await this.getData(`${this.apiUrlCreator(`vendoraddedfields?intVendorGatewayID=${intVendorGatewayID}`, CustomUrl.ONLINE_VENDOR_ORDERING)}`)
    return getvendoraddedfields
  }
  async getDynamicDBValues(intStoreID) {
    const getDynamicDBValues = await this.getData(`${this.apiUrlCreator(`getonlinevendordynamicdbvalues?intStoreID=${intStoreID}`, CustomUrl.ONLINE_VENDOR_ORDERING)}`)
    return getDynamicDBValues
  }
  async addNewFields(req) {
    const addNewFields = await this.postData(`${this.apiUrlCreator(`vendoraddedfields`, CustomUrl.ONLINE_VENDOR_ORDERING)}`, req)
    return addNewFields
  }
  async deletevendorField(intVendorAddedFieldsID) {
    const deletevendorField = await this.patchData(`${this.apiUrlCreator(`vendoraddedfields?intVendorAddedFieldsID=${intVendorAddedFieldsID}`, CustomUrl.ONLINE_VENDOR_ORDERING)}`)
    return deletevendorField
  }

  async getOnlinevendorauthorizationdetails(req) {
    const getDynamicDBValues = await this.getData(`${this.apiUrlCreator(`getonlinevendorauthorizationdetails?RitasStoreID=${req?.RitasStoreID}&intVendorGatewayID=${req?.intVendorGatewayID}&userName=${req?.userName}`, CustomUrl.ONLINE_VENDOR_ORDERING)}`)
    return getDynamicDBValues
  }
  async getUserRoles(req) {
    const getUserRoles = await this.postData(
      `${this.apiUrlCreator(`getuserroles`, CustomUrl.USERS)}`,
      req
    );
    return getUserRoles;
  }

  async getApps(sub) {
    return this.getData(this.apiUrlCreator(`apps?sub=${encodeURIComponent(sub)}`, CustomUrl.RFC_LIBRARY));
  }
  async getShopWebsiteCustomization(req) {
    const getDynamicDBValues = await this.postData(`${this.apiUrlCreator(`shopwebsettings`, CustomUrl.STORES)}`, req)
    return getDynamicDBValues
  }

  async getMenusList(intStoreID) {
    const getMenusList = await this.getData(`${this.apiUrlCreator(`products_menu?intStoreID=${intStoreID}`, CustomUrl.DMB_WEB_APP)}`)
    return getMenusList
  }

  async saveMenusList(req) {
    const menuslist = await this.postData(`${this.apiUrlCreator(`products_menu`, CustomUrl.DMB_WEB_APP)}`, req)
    return menuslist
  }

  async getAllGuestData(intStoreID, params) {
    const quryParam = params?.search ? `page=${params.page}&size=${params.size}&search=${params.search}` : `page=${params.page}&size=${params.size}`
    const guestData = await this.getData(`${this.apiUrlCreator(`guests`, CustomUrl.DMB_WEB_APP)}?intStoreID=${intStoreID}&${quryParam}`)
    return guestData
  }

  async deleteGuest(favGuiId) {
    const guestDelete = await this.patchData(`${this.apiUrlCreator(`guest`, CustomUrl.DMB_WEB_APP)}`, favGuiId)
    return guestDelete;
  }

  async fetchGuestFlavors(intStoreID) {
    let response = [];
    const manageFlavorsData = await this.getData(
      `${this.apiUrlCreator(`guest_flavors`, CustomUrl.DMB_WEB_APP)}?intStoreID=${intStoreID}`
    );
    if (manageFlavorsData) {
      response = manageFlavorsData || [];
    }
    return response;
  }


  async createGuest(guestPayload) {
    const response = await this.postData(`${this.apiUrlCreator(`guest`, CustomUrl.DMB_WEB_APP)}`, guestPayload);
    return response;
  }

  async getCoolAlertsReportData(intStoreID = "", key = "") {
    const response = await this.getData(`${this.apiUrlCreator(`getcoolalertsdata`, CustomUrl.DMB_WEB_APP)}?intStoreID=${intStoreID}&key=${key}`);
    return response?.data;
  }


  async getStoreSettings(intStoreID) {
    const response = await this.getData(`${this.apiUrlCreator(`getstoresettings?intStoreID=${intStoreID}`, CustomUrl.STORES)}`);
    return response;
  }

  async updateStoreSettings(req) {
    const response = await this.postData(`${this.apiUrlCreator(`updatestoresettings`, CustomUrl.STORES)}`, req);
    return response;
  }
  async fetchCreatives() {
    const response = await this.getData(`${this.apiUrlCreator(`creatives`, CustomUrl.DMB_WEB_APP)}`);
    return response;
  }
  async fetchStoreCreatives(intStoreID) {
    const response = await this.getData(`${this.apiUrlCreator(`storecreatives?intStoreID=${intStoreID}`, CustomUrl.DMB_WEB_APP)}`);
    return response;
  }
  async selectCreatives(req) {
    const response = await this.postData(`${this.apiUrlCreator(`storecreatives`, CustomUrl.DMB_WEB_APP)}`, req);
    return response;
  }

  async actionOnCreative(payload) {
    const response = await this.postData(`${this.apiUrlCreator(`creatives`, CustomUrl.DMB_WEB_APP)}`, payload);
    return response;
  }

  async getPromotionalEmailDetails(intStoreID) {
    const response = await this.getData(`${this.apiUrlCreator(`promotionalemail?intStoreID=${intStoreID}`, CustomUrl.DMB_WEB_APP)}`);
    return response?.data || {};
  }

  async getEmailTemplate(intStoreID, templateId = "", message = "") {
    const response = await this.getData(`${this.apiUrlCreator(`promotionalemailtemplate?intStoreID=${intStoreID}&id=${templateId}&msg=${message}`, CustomUrl.DMB_WEB_APP)}`);
    return response?.data || {};
  }

  async sendPromotionalEmail(payload) {
    const response = await this.postData(`${this.apiUrlCreator(`promotionalemail`, CustomUrl.DMB_WEB_APP)}`, payload);
    return response || {};
  }

  async getCateringOrders(intStoreID, params) {
    const queryParam = params?.search ? `page=${params.page}&size=${params.size}&search=${params.search}` : `page=${params.page}&size=${params.size}`;
    const guestData = await this.getData(`${this.apiUrlCreator(`catering-orders`, CustomUrl.CATERING_PORTAL)}?intStoreID=${intStoreID}&${queryParam}`);
    return guestData;
  };

  async updateOrderStatus(payload) {
    const response = await this.patchData(`${this.apiUrlCreator(`catering-orders`, CustomUrl.CATERING_PORTAL)}`, payload);
    return response;
  };

  async fetchCateringFlavors(intStoreID, req) {
    let response = [];
    const cateringFlavorsResponse = await this.getData(
      `${this.apiUrlCreator(`catering-flavors`, CustomUrl.CATERING_PORTAL)}?intStoreID=${intStoreID}`,
    );
    console.log('cateringFlavorsResponse ', cateringFlavorsResponse);
    if (cateringFlavorsResponse?.data) {
      response = cateringFlavorsResponse.data.data || [];
    }
    return response;
  }

  async updateCateringFlavors(req) {
    const fetchStoreCateringFlavors = await this.putData(
      `${this.apiUrlCreator(`catering-flavors`, CustomUrl.CATERING_PORTAL)}`,
      req
    );
    return fetchStoreCateringFlavors;
  }

  async fetchPLSalesKeys() {
    const response = await this.getData(`${this.apiUrlCreator(`plsaleskeys`, CustomUrl.PL_TOOL)}`);
    return response?.data;
  }

  async fetchPLApiValues(intStoreID, fiscalYear, month) {
    const monthNum = String(month).padStart(2, '0');
    const response = await this.getData(`${this.apiUrlCreator(`plsaleskeysvalues?store_id=${intStoreID}&year=${fiscalYear}&month=${monthNum}`, CustomUrl.PL_TOOL)}`);
    return response?.data;
  }

  async fetchPLBootstrap(intStoreID, fiscalYear, userRole) {
    const response = await this.getData(`${this.apiUrlCreator(`plbootstrap?intStoreID=${intStoreID}&fiscalYear=${fiscalYear}&userRole=${encodeURIComponent(userRole || 'User')}`, CustomUrl.PL_TOOL)}`);
    return response?.data;
  }

  async savePLPeriod(req) {
    const response = await this.postData(`${this.apiUrlCreator(`plsaveperiod`, CustomUrl.PL_TOOL)}`, req);
    return response;
  }

  async updatePLStatus(req) {
    const response = await this.postData(`${this.apiUrlCreator(`plupdatestatus`, CustomUrl.PL_TOOL)}`, req);
    return response;
  }

  async savePLCustomSchema(req) {
    const response = await this.postData(`${this.apiUrlCreator(`plcustomschema`, CustomUrl.PL_TOOL)}`, req);
    return response;
  }

  async submitPLReopenRequest(req) {
    const response = await this.postData(`${this.apiUrlCreator(`plreopenrequest`, CustomUrl.PL_TOOL)}`, { ...req, action: 'request' });
    return response;
  }

  async getPLReopenRequests(userRole) {
    const response = await this.getData(`${this.apiUrlCreator(`plreopenrequest?userRole=${encodeURIComponent(userRole || 'Admin')}`, CustomUrl.PL_TOOL)}`);
    return response?.data;
  }

  async resolvePLReopenRequest(req) {
    const response = await this.postData(`${this.apiUrlCreator(`plreopenrequest`, CustomUrl.PL_TOOL)}`, req);
    return response;
  }

  async getRfcLibraryDataFromS3(req, config = {}) {
    const dataFromS3 = await this.postData(
      `${this.apiUrlCreator(`getrfclibrarydatafroms3`, CustomUrl.RFC_LIBRARY)}`,
      req,
      config
    );
    return dataFromS3;
  }

  async uploadToRfcLibrary(payload) {
    // payload is a plain JSON object; Lambda routes by 'type': 'file' | 'folder'
    // File uploads use base64 JSON to avoid API Gateway binary media type issues
    const response = await this.postData(
      `${this.apiUrlCreator(`uploadS3FIleorFolder`, CustomUrl.RFC_LIBRARY)}`,
      payload
    );
    return response;
  }
}
